import { render, staticRenderFns } from "./AddNewCongress.vue?vue&type=template&id=305c6826&"
import script from "./AddNewCongress.vue?vue&type=script&lang=js&"
export * from "./AddNewCongress.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCongress.vue?vue&type=style&index=0&id=305c6826&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports